import * as api from "../api/user";
import { login } from "./auth";
import { START_PROGRESS, STOP_PROGRESS } from "./progress";
import { showNotification } from "./notification";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const LOAD_LOJA_SUCCESS = "LOAD_LOJA_SUCCESS";
export const LOAD_LOJA_FAIL = "LOAD_LOJA_FAIL";
export const UPDATE_LOJA_SUCCESS = "UPDATE_LOJA_SUCCESS";
export const UPDATE_LOJA_FAIL = "UPDATE_LOJA_FAIL";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_FORNECEDOR_SUCCESS = "UPDATE_FORNECEDOR_SUCCESS";
export const UPDATE_FORNECEDOR_FAIL = "UPDATE_FORNECEDOR_FAIL";
export const CRIAR_FORNECEDOR_SUCCESS = "CRIAR_FORNECEDOR_SUCCESS";
export const CRIAR_FORNECEDOR_FAIL = "CRIAR_FORNECEDOR_FAIL";
export const GET_ACOES_START = "GET_ACOES_START";
export const GET_ACOES_SUCCESS = "GET_ACOES_SUCCESS";
export const GET_ACOES_FAIL = "GET_ACOES_FAIL";
export const GET_VISITAS_START = "GET_VISITAS_START";
export const GET_VISITAS_SUCCESS = "GET_VISITAS_SUCCESS";
export const GET_VISITAS_FAIL = "GET_VISITAS_FAIL";

export const startLoading = () => ({
  type: START_LOADING,
});

export const stopLoading = () => ({
  type: STOP_LOADING,
});

export const registerUser = (user, navigate) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    const { data } = await api.cadastrarUsuario(user);
    dispatch({ type: REGISTER_SUCCESS, payload: data });
    await dispatch(login(user.email, user.password));
    window.localStorage.removeItem("vintree_onboarding_done");
    navigate("/app/onboarding");
    dispatch(
      showNotification({
        message: data?.message || "Cadastro realizado com sucesso.",
        color: data?.type || "success",
      })
    );
  } catch (error) {
    console.error("Erro ao registrar usuário:", error);
    const message = error?.message || "Erro ao cadastrar o usuário.";
    dispatch({
      type: REGISTER_FAIL,
      payload: message,
    });
    dispatch(
      showNotification({
        message,
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
  }
};

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    dispatch({ type: START_LOADING });

    const { data } = await api.getUser();
    dispatch({ type: LOAD_USER_SUCCESS, payload: data });

    dispatch(loadLoja());
  } catch (error) {
    console.error("Load User Error: ", error);
  } finally {
    dispatch({ type: STOP_PROGRESS });
    dispatch({ type: STOP_LOADING });
  }
};

export const loadLoja = () => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    dispatch({ type: START_LOADING });

    const { data } = await api.getLoja();
    dispatch({ type: LOAD_LOJA_SUCCESS, payload: data });
  } catch (error) {
    console.error("Erro ao carregar loja: ", error);
    dispatch({
      type: LOAD_LOJA_FAIL,
      payload: error.message || "Erro ao carregar a loja.",
    });
  } finally {
    dispatch({ type: STOP_PROGRESS });
    dispatch({ type: STOP_LOADING });
  }
};

export const atualizarLojaAction = (lojaForm) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    dispatch({ type: START_LOADING });

    const formData = new FormData();
    Object.entries(lojaForm).forEach(([key, value]) => {
      if (key === "updatedAt" || key === "updated_at") {
        return;
      }
      if (key === "profile_picture" && value instanceof Blob) {
        formData.append(key, value);
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    const { data } = await api.atualizarLoja(formData);

    dispatch({ type: UPDATE_LOJA_SUCCESS, payload: data });
    dispatch(
      showNotification({
        message: data?.message || "Informações da loja atualizadas com sucesso!",
        color: data?.type || "success",
      })
    );
  } catch (error) {
    console.error("Erro ao atualizar loja: ", error);
    const message = error?.message || "Erro ao atualizar a loja.";
    dispatch({
      type: UPDATE_LOJA_FAIL,
      payload: message,
    });
    dispatch(
      showNotification({
        message,
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
    dispatch({ type: STOP_LOADING });
  }
};

export const atualizarUsuarioAction = (userData) => async (dispatch) => {
  try {
    dispatch({ type: START_PROGRESS });
    dispatch({ type: START_LOADING });

    const { data } = await api.atualizarUsuario(userData);

    dispatch({ type: UPDATE_USER_SUCCESS, payload: data });
    dispatch(
      showNotification({
        message: data?.message || "Informações pessoais atualizadas com sucesso!",
        color: data?.type || "success",
      })
    );
  } catch (error) {
    console.error("Erro ao atualizar usuário: ", error);
    dispatch({
      type: UPDATE_USER_FAIL,
      payload: error.message,
    });
    dispatch(
      showNotification({
        message: error?.message || "Erro ao atualizar usuário.",
        color: error?.type || "failure",
      })
    );
  } finally {
    dispatch({ type: STOP_PROGRESS });
    dispatch({ type: STOP_LOADING });
  }
};

export const getAcoesAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ACOES_START });
    const data = await api.getAcoes();
    dispatch({ type: GET_ACOES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ACOES_FAIL, payload: error.message });
  }
};

export const getVisitasAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_VISITAS_START });
    const data = await api.getVisitas();
    dispatch({ type: GET_VISITAS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_VISITAS_FAIL, payload: error.message });
  }
};
